import React from 'react';
import { useLanguage } from '@/LanguageContext';
import { motion } from 'framer-motion';
import { ShieldCheck, Award, FileCheck, Factory, Link2, Lock } from 'lucide-react';

const Compliance = () => {
  const { t } = useLanguage();
  const icons = [ShieldCheck, Award, FileCheck, Factory, Link2, Lock];

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1, y: 0,
      transition: { duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] },
    }),
  };

  const items = t('compliance.items');

  return (
    <section id="compliance" data-testid="compliance-section" className="py-24 md:py-32 bg-[#F4F7FB]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <motion.p
            variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} custom={0}
            className="text-[#C5A55A] text-sm font-mono tracking-[0.3em] uppercase mb-4"
          >
            {t('compliance.overline')}
          </motion.p>
          <motion.h2
            variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} custom={1}
            className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-[#0A1628] mb-4"
            data-testid="compliance-title"
          >
            {t('compliance.title')}
          </motion.h2>
          <motion.p
            variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} custom={2}
            className="text-slate-600 text-base md:text-lg leading-relaxed max-w-2xl mx-auto"
          >
            {t('compliance.subtitle')}
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} custom={i + 3}
                className="group bg-white border border-slate-100 p-8 hover:shadow-xl hover:border-[#C5A55A] transition-all duration-500 hover:-translate-y-1"
                data-testid={`compliance-card-${i}`}
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#0A1628] mb-6 group-hover:bg-[#C5A55A] transition-colors duration-300">
                  <Icon className="w-5 h-5 text-[#C5A55A] group-hover:text-[#0A1628] transition-colors duration-300" />
                </div>
                <h3 className="font-heading text-lg font-semibold text-[#0A1628] mb-3">{item.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Compliance;
